import React from "react";

export default function SolarClipboardCheckOutline(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.2em"
      height="1.2em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.263 3.259A2.25 2.25 0 0 1 9.5 1.25h5a2.25 2.25 0 0 1 2.237 2.009c.763.015 1.423.055 1.987.158c.758.14 1.403.405 1.928.93c.602.602.86 1.36.982 2.26c.116.866.116 1.969.116 3.336v6.11c0 1.368 0 2.47-.116 3.337c-.122.9-.38 1.658-.982 2.26s-1.36.86-2.26.982c-.867.116-1.97.116-3.337.116h-6.11c-1.367 0-2.47 0-3.337-.116c-.9-.121-1.658-.38-2.26-.982s-.86-1.36-.981-2.26c-.117-.867-.117-1.97-.117-3.337v-6.11c0-1.367 0-2.47.117-3.336c.12-.9.38-1.658.981-2.26c.525-.525 1.17-.79 1.928-.93c.564-.103 1.224-.143 1.987-.158m.002 1.5c-.718.015-1.272.052-1.718.134c-.566.104-.895.27-1.138.514c-.277.277-.457.666-.556 1.4c-.101.755-.103 1.756-.103 3.191v6c0 1.436.002 2.437.103 3.192c.099.734.28 1.122.556 1.4c.277.276.665.457 1.4.555c.754.102 1.756.103 3.191.103h6c1.435 0 2.436-.001 3.192-.103c.734-.098 1.122-.279 1.399-.556c.277-.276.457-.665.556-1.399c.101-.755.103-1.756.103-3.192v-6c0-1.435-.002-2.436-.103-3.192c-.099-.733-.28-1.122-.556-1.399c-.244-.243-.572-.41-1.138-.514c-.446-.082-1-.119-1.718-.134A2.25 2.25 0 0 1 14.5 6.75h-5a2.25 2.25 0 0 1-2.235-1.99M9.5 2.75a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75zm6.048 7.738a.75.75 0 0 1-.036 1.06l-4.286 4a.75.75 0 0 1-1.024 0l-1.714-1.6a.75.75 0 1 1 1.024-1.096l1.202 1.122l3.774-3.522a.75.75 0 0 1 1.06.036"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
